var map = {
	"./1920x800-01.jpg": "7552",
	"./500x500-01.jpg": "a8e0",
	"./apidays-2023/images/apidays-2023-logo.png": "9165",
	"./apidays-2023/images/apidays-day2-highlights.jpg": "7641",
	"./apidays-2023/images/apidays-event-image.jpg": "6655",
	"./apidays-2023/images/apidays-hongkong-2023-agenda-0830.png": "695d",
	"./apidays-2023/images/apidays-hongkong-2023-agenda-0831.png": "337d",
	"./apidays-2023/images/apidays-top-5-reasons.jpg": "db93",
	"./apidays-2023/images/day-1/1.jpg": "0955",
	"./apidays-2023/images/day-1/10.jpg": "42c2",
	"./apidays-2023/images/day-1/11.jpg": "2ef6",
	"./apidays-2023/images/day-1/12.jpg": "c5c7",
	"./apidays-2023/images/day-1/13.jpg": "0faf",
	"./apidays-2023/images/day-1/14.jpg": "4d1f",
	"./apidays-2023/images/day-1/15.jpg": "2475",
	"./apidays-2023/images/day-1/16.jpg": "b98b",
	"./apidays-2023/images/day-1/17.jpg": "b209",
	"./apidays-2023/images/day-1/18.jpg": "0f25",
	"./apidays-2023/images/day-1/2.jpg": "a238",
	"./apidays-2023/images/day-1/3.jpg": "4712",
	"./apidays-2023/images/day-1/4.jpg": "4dab",
	"./apidays-2023/images/day-1/5.jpg": "9d15",
	"./apidays-2023/images/day-1/6.jpg": "79e4",
	"./apidays-2023/images/day-1/7.jpg": "a335",
	"./apidays-2023/images/day-1/8.jpg": "05b1",
	"./apidays-2023/images/day-1/9.jpg": "1104",
	"./apidays-2023/images/day-1/onsite-1.jpg": "3f84",
	"./apidays-2023/images/day-2/1.png": "5771",
	"./apidays-2023/images/day-2/2.png": "8394",
	"./apidays-2023/images/day-2/3.png": "3d8b",
	"./apidays-2023/images/day-2/4.png": "4ec3",
	"./apidays-2023/images/day-2/5.png": "503c",
	"./apidays-2023/images/day-2/6.png": "d18f",
	"./apidays-2023/images/hkstp-location.jpg": "8537",
	"./apidays-2023/images/luck-draw-banner.jpg": "a11b",
	"./apidays-2023/images/oah-blog-cover.jpg": "afe6",
	"./apidays-2023/images/the-top-5-challenges-in-implementing-api-strategy.jpg": "4fa7",
	"./apidays-2023/images/video-cover.jpg": "9590",
	"./apidays-2023/organizers/alibaba-cloud.png": "c9d3",
	"./apidays-2023/organizers/amadeus.png": "bedb",
	"./apidays-2023/organizers/apidays-2023.png": "a474",
	"./apidays-2023/organizers/apisfirst.png": "7a65",
	"./apidays-2023/organizers/atlassian-community.png": "1cc0",
	"./apidays-2023/organizers/auth0.png": "e27d",
	"./apidays-2023/organizers/aws.png": "4cab",
	"./apidays-2023/organizers/benovelty.png": "7c2c",
	"./apidays-2023/organizers/confluent.png": "bf0d",
	"./apidays-2023/organizers/dala.png": "ee41",
	"./apidays-2023/organizers/daops.png": "3c98",
	"./apidays-2023/organizers/f5.png": "dc6e",
	"./apidays-2023/organizers/fabrix.png": "a239",
	"./apidays-2023/organizers/fabrixapi.png": "4b16",
	"./apidays-2023/organizers/forgerock.png": "6d27",
	"./apidays-2023/organizers/hkcs.png": "5316",
	"./apidays-2023/organizers/hkstp-2023.png": "3c13",
	"./apidays-2023/organizers/hkstp-saa.png": "17a8",
	"./apidays-2023/organizers/hkstpsaa.png": "0e65",
	"./apidays-2023/organizers/ibm.png": "c162",
	"./apidays-2023/organizers/ifta.png": "d4aa",
	"./apidays-2023/organizers/isoc.png": "8c47",
	"./apidays-2023/organizers/moongate.png": "dbf9",
	"./apidays-2023/organizers/mulesoft.png": "4060",
	"./apidays-2023/organizers/new-relic.png": "851c",
	"./apidays-2023/organizers/nginx-f5.png": "546f",
	"./apidays-2023/organizers/nginx.png": "184e",
	"./apidays-2023/organizers/on-us.png": "60b6",
	"./apidays-2023/organizers/openapihub.png": "f572",
	"./apidays-2023/organizers/softwareag.png": "2ce1",
	"./apidays-2023/organizers/suse.png": "3017",
	"./apidays-2023/organizers/wia.png": "de92",
	"./apidays-2023/organizers/wso2.png": "b2b4",
	"./apidays-2023/speakers/albert-pro.jpg": "7460",
	"./apidays-2023/speakers/alvin-pro.jpg": "c977",
	"./apidays-2023/speakers/amin-pro.jpg": "93aa",
	"./apidays-2023/speakers/andrew-pro.jpg": "0189",
	"./apidays-2023/speakers/arthur-pro.jpg": "b254",
	"./apidays-2023/speakers/asanka-pro.jpg": "9f03",
	"./apidays-2023/speakers/barry-pro.jpg": "4a75",
	"./apidays-2023/speakers/ben-pro.jpg": "0730",
	"./apidays-2023/speakers/brenton-pro.jpg": "e41c",
	"./apidays-2023/speakers/brian-pro.jpg": "6840",
	"./apidays-2023/speakers/clive-pro.jpg": "f129",
	"./apidays-2023/speakers/crystal-pro.jpg": "c2b9",
	"./apidays-2023/speakers/dale-pro.jpg": "6ea3",
	"./apidays-2023/speakers/dave-pro.jpg": "9190",
	"./apidays-2023/speakers/davep-pro.jpg": "bb28",
	"./apidays-2023/speakers/dennis-pro.jpg": "a7db",
	"./apidays-2023/speakers/derric-pro.jpg": "4b29",
	"./apidays-2023/speakers/dipin-pro.jpg": "5711",
	"./apidays-2023/speakers/divesh-pro.jpg": "eaec",
	"./apidays-2023/speakers/eason-pro.jpg": "30ba",
	"./apidays-2023/speakers/enrico-pro.jpg": "de5d",
	"./apidays-2023/speakers/giri-pro.jpg": "0a75",
	"./apidays-2023/speakers/grace-pro.jpg": "9c03",
	"./apidays-2023/speakers/harish-pro.jpg": "fd38",
	"./apidays-2023/speakers/img12.jpg": "2724",
	"./apidays-2023/speakers/ivan-pro.jpg": "2a85",
	"./apidays-2023/speakers/jed-pro.jpg": "af6a",
	"./apidays-2023/speakers/jennifer-pro.jpg": "669d",
	"./apidays-2023/speakers/jeremyg-pro.jpg": "f922",
	"./apidays-2023/speakers/jeremys-pro.jpg": "6657",
	"./apidays-2023/speakers/jerry-pro.jpg": "90dc",
	"./apidays-2023/speakers/jigar-pro.jpg": "7f1a",
	"./apidays-2023/speakers/johnny-pro.jpg": "78eb8",
	"./apidays-2023/speakers/juni-pro.jpg": "6591",
	"./apidays-2023/speakers/justy-pro.jpg": "67e3",
	"./apidays-2023/speakers/kelvin-pro.jpg": "709e",
	"./apidays-2023/speakers/lareina-pro.jpg": "2ab9",
	"./apidays-2023/speakers/man-pro.jpg": "bc1b",
	"./apidays-2023/speakers/mark-pro.jpg": "9895",
	"./apidays-2023/speakers/martin-pro.jpg": "7449",
	"./apidays-2023/speakers/mary-pro.jpg": "948a",
	"./apidays-2023/speakers/matt-pro.jpg": "2286",
	"./apidays-2023/speakers/matthew-pro.jpg": "7a96",
	"./apidays-2023/speakers/matthias-pro.jpg": "295b",
	"./apidays-2023/speakers/medhy-pro.jpg": "0f81",
	"./apidays-2023/speakers/mehdi-pro.jpg": "ccbc",
	"./apidays-2023/speakers/michaela-pro.jpg": "9356",
	"./apidays-2023/speakers/michaely-pro.jpg": "c3b7",
	"./apidays-2023/speakers/ming-pro.jpg": "5c00",
	"./apidays-2023/speakers/nauman-pro.jpg": "ca2b",
	"./apidays-2023/speakers/olivier-pro.jpg": "2fac",
	"./apidays-2023/speakers/patrick-pro.jpg": "b7fc",
	"./apidays-2023/speakers/paul-pro.jpg": "3651",
	"./apidays-2023/speakers/richard-pro.jpg": "fea7",
	"./apidays-2023/speakers/rob-pro.jpg": "29e1",
	"./apidays-2023/speakers/shahnawaz-pro.jpg": "8acb",
	"./apidays-2023/speakers/shain-pro.jpg": "0f61",
	"./apidays-2023/speakers/steven-pro.jpg": "1e8b",
	"./apidays-2023/speakers/tim-pro.jpg": "4476",
	"./apidays-2023/speakers/toa-pro.jpg": "458a",
	"./apidays-2023/speakers/tony-pro.jpg": "050a",
	"./apidays-2023/speakers/tracy-pro.jpg": "9204",
	"./apidays-2023/speakers/vishal-pro.jpg": "980c",
	"./apidays-2023/thumbnails/fabrixapi-booth-video.jpg": "4569",
	"./apidays-2023/thumbnails/nginx-booth-video.png": "4a93",
	"./apidays-2023/thumbnails/softwareag-booth-video.png": "448e",
	"./apidays-2023/thumbnails/suse-booth-video.png": "f131",
	"./apidays-2023/tickets/api-warrior-gold.jpg": "f5bb",
	"./apidays-2023/tickets/api-warrior-silver.jpg": "9ec1",
	"./awards/ciia-2022.jpg": "e1c8",
	"./awards/erb-md.jpg": "71fd",
	"./awards/fintech-awards-2020.jpg": "0a5b",
	"./awards/hk-ict-awards-2020-silver.jpg": "abae",
	"./awards/ifta-2019.jpg": "dd7e",
	"./banners/event-banner-01.jpg": "2b54",
	"./banners/event-banner-02.jpg": "6bbe",
	"./banners/event-banner-03.jpg": "0af3",
	"./banners/event-banner-04.jpg": "44a9",
	"./certificates/ISO27001-cert-1.jpg": "1110",
	"./certificates/ISO27001-cert-2.jpg": "53c0",
	"./certificates/ISO27001.jpg": "a9e0",
	"./certificates/cert-graphic.png": "1ef0",
	"./certificates/duns-registered-cert.jpg": "762e",
	"./certificates/duns-registered.jpg": "6074",
	"./certificates/hkqaa-hkregistration-cert.jpg": "e956",
	"./certificates/hkqaa-hkregistration.jpg": "bdfa",
	"./events/apidays-live-hongkong/2021/images/apidays-2021-banner.jpg": "4e32",
	"./events/apidays-live-hongkong/2021/images/apidays-2021-snapshot-1.jpg": "9196",
	"./events/apidays-live-hongkong/2021/images/apidays-2021-snapshot-2.jpg": "c4e7",
	"./events/apidays-live-hongkong/2021/images/apidays-2021-snapshot-3.jpg": "e0fd",
	"./events/apidays-live-hongkong/2021/images/apidays-2021-snapshot-4.jpg": "9395",
	"./events/apidays-live-hongkong/2021/images/apidays-2021-snapshot-5.jpg": "9fba",
	"./events/apidays-live-hongkong/2021/images/apidays-2021-snapshot-6.jpg": "84fb",
	"./events/apidays-live-hongkong/2021/images/apidays-live-hongkong-2021-agenda-825.png": "5b2d",
	"./events/apidays-live-hongkong/2021/images/apidays-live-hongkong-2021-agenda-826.png": "9290",
	"./events/apidays-live-hongkong/2021/images/apidays-live-hongkong-2021-participants.png": "3e92",
	"./events/apidays-live-hongkong/2021/images/apidays-live-hongkong-2021-video-cover.jpg": "a35f",
	"./events/apidays-live-hongkong/2021/images/hongkong.jpg": "2aa0",
	"./events/apidays-live-hongkong/2021/speakers/ajay-pro.jpg": "f0d5",
	"./events/apidays-live-hongkong/2021/speakers/alanc-pro.jpg": "800c",
	"./events/apidays-live-hongkong/2021/speakers/alang-pro.jpg": "b310",
	"./events/apidays-live-hongkong/2021/speakers/andrew-pro.jpg": "16bc",
	"./events/apidays-live-hongkong/2021/speakers/archana-pro.jpg": "ecf7",
	"./events/apidays-live-hongkong/2021/speakers/asanka-pro.jpg": "3333",
	"./events/apidays-live-hongkong/2021/speakers/carl-pro.jpg": "7dfc",
	"./events/apidays-live-hongkong/2021/speakers/claire-pro.jpg": "15c2",
	"./events/apidays-live-hongkong/2021/speakers/clive-pro.jpg": "c665",
	"./events/apidays-live-hongkong/2021/speakers/damir-pro.jpg": "636c",
	"./events/apidays-live-hongkong/2021/speakers/david-pro.jpg": "bcb9",
	"./events/apidays-live-hongkong/2021/speakers/default-speaker.jpg": "68b5",
	"./events/apidays-live-hongkong/2021/speakers/derek-pro.jpg": "4558",
	"./events/apidays-live-hongkong/2021/speakers/div-pro.jpg": "041d",
	"./events/apidays-live-hongkong/2021/speakers/eason-pro.jpg": "63b0",
	"./events/apidays-live-hongkong/2021/speakers/emmelyn-pro.jpg": "1593",
	"./events/apidays-live-hongkong/2021/speakers/gan-pro.jpg": "1354",
	"./events/apidays-live-hongkong/2021/speakers/geoffrey-pro.jpg": "ade4",
	"./events/apidays-live-hongkong/2021/speakers/greg-pro.jpg": "1d8f",
	"./events/apidays-live-hongkong/2021/speakers/hieu-pro.jpg": "2140",
	"./events/apidays-live-hongkong/2021/speakers/howard-pro.jpg": "018f",
	"./events/apidays-live-hongkong/2021/speakers/hugo-pro.jpg": "220e",
	"./events/apidays-live-hongkong/2021/speakers/isaac-pro.jpg": "3616",
	"./events/apidays-live-hongkong/2021/speakers/jason-pro.jpg": "1454",
	"./events/apidays-live-hongkong/2021/speakers/jeffrey-pro.jpg": "e80e",
	"./events/apidays-live-hongkong/2021/speakers/jenks-pro.jpg": "b545",
	"./events/apidays-live-hongkong/2021/speakers/jeremy-pro.jpg": "bd34",
	"./events/apidays-live-hongkong/2021/speakers/jesus-pro.jpg": "7410",
	"./events/apidays-live-hongkong/2021/speakers/jimmy-pro.jpg": "8fd2",
	"./events/apidays-live-hongkong/2021/speakers/john-pro.jpg": "172c",
	"./events/apidays-live-hongkong/2021/speakers/jonathan-pro.jpg": "253f",
	"./events/apidays-live-hongkong/2021/speakers/kim-pro.jpg": "4b7c",
	"./events/apidays-live-hongkong/2021/speakers/laurent-pro.jpg": "2f7f",
	"./events/apidays-live-hongkong/2021/speakers/marco-pro.jpg": "33d9",
	"./events/apidays-live-hongkong/2021/speakers/marjukka-pro.jpg": "627d",
	"./events/apidays-live-hongkong/2021/speakers/mathieu-pro.jpg": "0720",
	"./events/apidays-live-hongkong/2021/speakers/matthias-pro.jpg": "5274",
	"./events/apidays-live-hongkong/2021/speakers/maxime-pro.jpg": "290c",
	"./events/apidays-live-hongkong/2021/speakers/maximeb-pro.jpg": "ff2b",
	"./events/apidays-live-hongkong/2021/speakers/maximet-pro.jpg": "35b6",
	"./events/apidays-live-hongkong/2021/speakers/mehdi-pro.jpg": "c2ab",
	"./events/apidays-live-hongkong/2021/speakers/morris-pro.jpg": "b7c8",
	"./events/apidays-live-hongkong/2021/speakers/naveen-pro.jpg": "41fe",
	"./events/apidays-live-hongkong/2021/speakers/nicky-pro.jpg": "67c6",
	"./events/apidays-live-hongkong/2021/speakers/nitin-pro.jpg": "7b52",
	"./events/apidays-live-hongkong/2021/speakers/patrick-pro.jpg": "9ee6",
	"./events/apidays-live-hongkong/2021/speakers/phil-pro.jpg": "bc63",
	"./events/apidays-live-hongkong/2021/speakers/pricilla-pro.jpg": "7d65",
	"./events/apidays-live-hongkong/2021/speakers/rana-pro.jpg": "3c41",
	"./events/apidays-live-hongkong/2021/speakers/richard-pro.jpg": "5a4b",
	"./events/apidays-live-hongkong/2021/speakers/rob-pro.jpg": "5b14",
	"./events/apidays-live-hongkong/2021/speakers/rosemary-pro.jpg": "7d28",
	"./events/apidays-live-hongkong/2021/speakers/shahnawaz-pro.jpg": "fdfe",
	"./events/apidays-live-hongkong/2021/speakers/shiroshica-pro.jpg": "3c1c",
	"./events/apidays-live-hongkong/2021/speakers/siddhant-pro.jpg": "0e54",
	"./events/apidays-live-hongkong/2021/speakers/simen-pro.jpg": "8654",
	"./events/apidays-live-hongkong/2021/speakers/simon-pro.jpg": "df80",
	"./events/apidays-live-hongkong/2021/speakers/simonw-pro.jpg": "c0b0",
	"./events/apidays-live-hongkong/2021/speakers/snehal-pro.jpg": "2505",
	"./events/apidays-live-hongkong/2021/speakers/stuart-pro.jpg": "25e6",
	"./events/apidays-live-hongkong/2021/speakers/tharika-pro.jpg": "5863",
	"./events/apidays-live-hongkong/2021/speakers/toa-pro.jpg": "c958",
	"./events/apidays-live-hongkong/2021/speakers/trevor-pro.jpg": "969b7",
	"./events/apidays-live-hongkong/2021/speakers/uli-pro.jpg": "33e5",
	"./events/apidays-live-hongkong/2021/sponsors/amadeus.png": "e23f",
	"./events/apidays-live-hongkong/2021/sponsors/confluent.png": "37bd",
	"./events/apidays-live-hongkong/2021/sponsors/hkcs.png": "110d",
	"./events/apidays-live-hongkong/2021/sponsors/hkstpsaa.png": "454e",
	"./events/apidays-live-hongkong/2021/sponsors/ibm.png": "0215",
	"./events/apidays-live-hongkong/2021/sponsors/mulesoft.png": "d993",
	"./events/apidays-live-hongkong/2021/sponsors/new-relic.png": "d5c5",
	"./events/apidays-live-hongkong/2021/sponsors/softwareag.png": "d4b6",
	"./events/apidays-live-hongkong/2022/images/apidays-2022-snapshot-1.jpg": "a03c",
	"./events/apidays-live-hongkong/2022/images/apidays-2022-snapshot-2.jpg": "53d4",
	"./events/apidays-live-hongkong/2022/images/apidays-2022-snapshot-charm-1.jpg": "013c",
	"./events/apidays-live-hongkong/2022/images/apidays-2022-snapshot-gary-1.jpg": "ace2",
	"./events/apidays-live-hongkong/2022/images/apidays-2022-snapshot-richard-1.jpg": "6f89",
	"./events/apidays-live-hongkong/2022/images/apidays-2022-snapshot-trevor-1.jpg": "d21d",
	"./events/apidays-live-hongkong/2022/images/apidays-hongkong-2022-agenda-0824.png": "72f9",
	"./events/apidays-live-hongkong/2022/images/apidays-hongkong-2022-agenda-0825.png": "0259",
	"./events/apidays-live-hongkong/2022/images/apidays-hongkong-2022-logo.png": "e9b8",
	"./events/apidays-live-hongkong/2022/images/apidays-hongkong-2022-participants.jpg": "66f1",
	"./events/apidays-live-hongkong/2022/images/apidays-hongkong-2022-video-cover.jpg": "8921",
	"./events/apidays-live-hongkong/2022/speakers/alvin-pro.jpg": "2230",
	"./events/apidays-live-hongkong/2022/speakers/bob-pro.jpg": "10dc",
	"./events/apidays-live-hongkong/2022/speakers/brad-pro.jpg": "cb1f",
	"./events/apidays-live-hongkong/2022/speakers/christine-pro.jpg": "6941",
	"./events/apidays-live-hongkong/2022/speakers/clive-pro.jpg": "8193",
	"./events/apidays-live-hongkong/2022/speakers/dale-pro.jpg": "e9b7",
	"./events/apidays-live-hongkong/2022/speakers/default-speaker.jpg": "b082",
	"./events/apidays-live-hongkong/2022/speakers/derric-pro.jpg": "39c1",
	"./events/apidays-live-hongkong/2022/speakers/developersteve-pro.jpg": "67a7",
	"./events/apidays-live-hongkong/2022/speakers/eason-pro.jpg": "5a54",
	"./events/apidays-live-hongkong/2022/speakers/enrique-pro.jpg": "521d",
	"./events/apidays-live-hongkong/2022/speakers/frederic-pro.jpg": "cfae",
	"./events/apidays-live-hongkong/2022/speakers/gary-pro.jpg": "83c8",
	"./events/apidays-live-hongkong/2022/speakers/garyl-pro.jpg": "3789",
	"./events/apidays-live-hongkong/2022/speakers/giovanni-pro.jpg": "be94",
	"./events/apidays-live-hongkong/2022/speakers/giri-pro.jpg": "9aac",
	"./events/apidays-live-hongkong/2022/speakers/issac-pro.jpg": "089c",
	"./events/apidays-live-hongkong/2022/speakers/jeffrey-pro.jpg": "a613",
	"./events/apidays-live-hongkong/2022/speakers/jeremy-pro.jpg": "d8b4",
	"./events/apidays-live-hongkong/2022/speakers/jimmy-pro.jpg": "cf39",
	"./events/apidays-live-hongkong/2022/speakers/joey-pro.jpg": "6eb8",
	"./events/apidays-live-hongkong/2022/speakers/jonathan-pro.jpg": "835d",
	"./events/apidays-live-hongkong/2022/speakers/kenneth-pro.jpg": "4091",
	"./events/apidays-live-hongkong/2022/speakers/martin-pro.jpg": "8b6f",
	"./events/apidays-live-hongkong/2022/speakers/mary-pro.jpg": "4475",
	"./events/apidays-live-hongkong/2022/speakers/matt-pro.jpg": "0661",
	"./events/apidays-live-hongkong/2022/speakers/mehdi-pro.jpg": "53b9",
	"./events/apidays-live-hongkong/2022/speakers/michael-pro.jpg": "ac05",
	"./events/apidays-live-hongkong/2022/speakers/motti-pro.jpg": "5bc3",
	"./events/apidays-live-hongkong/2022/speakers/nelson-pro.jpg": "1539",
	"./events/apidays-live-hongkong/2022/speakers/nicolas-pro.jpg": "1b7f",
	"./events/apidays-live-hongkong/2022/speakers/patrick-pro.jpg": "4c8e",
	"./events/apidays-live-hongkong/2022/speakers/paul-pro.jpg": "1f07",
	"./events/apidays-live-hongkong/2022/speakers/ray-pro.jpg": "3805",
	"./events/apidays-live-hongkong/2022/speakers/richard-pro.jpg": "23ae",
	"./events/apidays-live-hongkong/2022/speakers/rob-pro.jpg": "1031",
	"./events/apidays-live-hongkong/2022/speakers/sanvy-pro.jpg": "a5d8",
	"./events/apidays-live-hongkong/2022/speakers/simon-pro.jpg": "4efd",
	"./events/apidays-live-hongkong/2022/speakers/sonal-pro.jpg": "9027",
	"./events/apidays-live-hongkong/2022/speakers/steve-pro.jpg": "f58e",
	"./events/apidays-live-hongkong/2022/speakers/steven-pro.jpg": "d8e0",
	"./events/apidays-live-hongkong/2022/speakers/sunny-pro.jpg": "d388",
	"./events/apidays-live-hongkong/2022/speakers/toa-pro.jpg": "1fd1",
	"./events/apidays-live-hongkong/2022/speakers/trevor-pro.jpg": "bff7",
	"./events/apidays-live-hongkong/2022/speakers/uli-pro.jpg": "7a68",
	"./events/apidays-live-hongkong/2022/speakers/wilson-pro.jpg": "de66",
	"./events/apidays-live-hongkong/2022/speakers/zhiyuan-pro.jpg": "9b31",
	"./events/apidays-live-hongkong/2022/sponsors/aws.png": "ffc1",
	"./events/apidays-live-hongkong/2022/sponsors/confluent.png": "5dc0",
	"./events/apidays-live-hongkong/2022/sponsors/hkcs.png": "af3d",
	"./events/apidays-live-hongkong/2022/sponsors/hkstpsaa.png": "f58ea",
	"./events/apidays-live-hongkong/2022/sponsors/new-relic.png": "e2fc",
	"./events/apidays-live-hongkong/2022/sponsors/openapihub.png": "ca48",
	"./events/apidays-live-hongkong/images/apidays-2020-facts.png": "2f9b",
	"./events/apidays-live-hongkong/images/apidays-HongKong-logowall.png": "dce6",
	"./events/apidays-live-hongkong/images/apidays-banner-light.jpg": "c68a",
	"./events/apidays-live-hongkong/images/apidays-banner.jpg": "9848",
	"./events/apidays-live-hongkong/images/apidays-live-hongkong-2020agenda.png": "c9a2",
	"./events/apidays-live-hongkong/images/apidays-onsite-1.jpg": "2102",
	"./events/apidays-live-hongkong/images/apidays-onsite-2.jpg": "e25e1",
	"./events/apidays-live-hongkong/images/apidays-onsite-3.jpg": "c3f6",
	"./events/apidays-live-hongkong/images/apidays-ppt-1.png": "72c2",
	"./events/apidays-live-hongkong/images/apidays-ppt-2.png": "8c73",
	"./events/apidays-live-hongkong/images/apidays-ppt-3.png": "9c49",
	"./events/apidays-live-hongkong/images/apidays-ppt-4.png": "2969",
	"./events/apidays-live-hongkong/images/apidays-ppt-5.png": "3c06",
	"./events/apidays-live-hongkong/images/apidays.jpg": "c47d",
	"./events/apidays-live-hongkong/organisers/apidays-2022.png": "f318",
	"./events/apidays-live-hongkong/organisers/apidays-live-hk-color.png": "8fac",
	"./events/apidays-live-hongkong/organisers/apidays.png": "b8da",
	"./events/apidays-live-hongkong/organisers/benovelty.png": "f858",
	"./events/apidays-live-hongkong/organisers/hkstp.png": "dae5",
	"./events/apidays-live-hongkong/speakers/alan-pro.jpg": "7cec",
	"./events/apidays-live-hongkong/speakers/alan-smc.jpg": "30a6",
	"./events/apidays-live-hongkong/speakers/alex-pro.jpg": "2f83",
	"./events/apidays-live-hongkong/speakers/alex-smc.jpg": "c5af",
	"./events/apidays-live-hongkong/speakers/anna-pro.jpg": "6723",
	"./events/apidays-live-hongkong/speakers/anna-smc.jpg": "3077",
	"./events/apidays-live-hongkong/speakers/asanka-pro.jpg": "b954",
	"./events/apidays-live-hongkong/speakers/asanka-smc.jpg": "49b6",
	"./events/apidays-live-hongkong/speakers/atsushi-pro.jpg": "6d75",
	"./events/apidays-live-hongkong/speakers/atsushi-smc.jpg": "aa4a",
	"./events/apidays-live-hongkong/speakers/barry-pro.jpg": "7e45",
	"./events/apidays-live-hongkong/speakers/barry-smc.jpg": "f8f0",
	"./events/apidays-live-hongkong/speakers/ben-pro.jpg": "38d5",
	"./events/apidays-live-hongkong/speakers/ben-smc.jpg": "df7d",
	"./events/apidays-live-hongkong/speakers/daniele-pro.jpg": "119e",
	"./events/apidays-live-hongkong/speakers/daniele-smc.jpg": "cbc1",
	"./events/apidays-live-hongkong/speakers/david-pro.jpg": "b63e",
	"./events/apidays-live-hongkong/speakers/david-smc.jpg": "2277",
	"./events/apidays-live-hongkong/speakers/developersteve-pro.jpg": "bc27",
	"./events/apidays-live-hongkong/speakers/developersteve-smc.jpg": "f888",
	"./events/apidays-live-hongkong/speakers/donnie-pro.jpg": "7933",
	"./events/apidays-live-hongkong/speakers/donnie-smc.jpg": "419c",
	"./events/apidays-live-hongkong/speakers/forest-pro.jpg": "6366",
	"./events/apidays-live-hongkong/speakers/forest-smc.jpg": "5707",
	"./events/apidays-live-hongkong/speakers/fran-pro.jpg": "5569",
	"./events/apidays-live-hongkong/speakers/fran-smc.jpg": "24c2",
	"./events/apidays-live-hongkong/speakers/garry-pro.jpg": "aa2f",
	"./events/apidays-live-hongkong/speakers/garry-smc.jpg": "8b24",
	"./events/apidays-live-hongkong/speakers/greg-pro.jpg": "3539",
	"./events/apidays-live-hongkong/speakers/greg-smc.jpg": "0bb9",
	"./events/apidays-live-hongkong/speakers/helal-pro.jpg": "ff9a",
	"./events/apidays-live-hongkong/speakers/helal-smc.jpg": "63ff",
	"./events/apidays-live-hongkong/speakers/hieu-pro.jpg": "8065",
	"./events/apidays-live-hongkong/speakers/hieu-smc.jpg": "fd99",
	"./events/apidays-live-hongkong/speakers/hugo-pro.jpg": "a2ee",
	"./events/apidays-live-hongkong/speakers/hugo-smc.jpg": "6259",
	"./events/apidays-live-hongkong/speakers/ilona-pro.jpg": "fded",
	"./events/apidays-live-hongkong/speakers/ilona-smc.jpg": "1074",
	"./events/apidays-live-hongkong/speakers/img12.jpg": "6681",
	"./events/apidays-live-hongkong/speakers/jed-pro.jpg": "b05a",
	"./events/apidays-live-hongkong/speakers/jed-smc.jpg": "123e",
	"./events/apidays-live-hongkong/speakers/jenks-pro.jpg": "85c4",
	"./events/apidays-live-hongkong/speakers/jenks-smc.jpg": "6e42",
	"./events/apidays-live-hongkong/speakers/johan-pro.jpg": "c593",
	"./events/apidays-live-hongkong/speakers/johan-smc.jpg": "5341",
	"./events/apidays-live-hongkong/speakers/john-pro.jpg": "0717",
	"./events/apidays-live-hongkong/speakers/john-smc.jpg": "3686",
	"./events/apidays-live-hongkong/speakers/julian-pro.jpg": "bba8",
	"./events/apidays-live-hongkong/speakers/julian-smc.jpg": "e8ab",
	"./events/apidays-live-hongkong/speakers/maciej-pro.jpg": "0241",
	"./events/apidays-live-hongkong/speakers/maciej-smc.jpg": "b475",
	"./events/apidays-live-hongkong/speakers/marco-pro.jpg": "0481",
	"./events/apidays-live-hongkong/speakers/marco-smc.jpg": "f30d",
	"./events/apidays-live-hongkong/speakers/michelle-pro.jpg": "7711",
	"./events/apidays-live-hongkong/speakers/michelle-smc.jpg": "ea4c",
	"./events/apidays-live-hongkong/speakers/nicky-pro.jpg": "c015",
	"./events/apidays-live-hongkong/speakers/nicky-smc.jpg": "f282",
	"./events/apidays-live-hongkong/speakers/patrick-pro.jpg": "cd34",
	"./events/apidays-live-hongkong/speakers/patrick-smc.jpg": "8724",
	"./events/apidays-live-hongkong/speakers/paul-pro.jpg": "042f",
	"./events/apidays-live-hongkong/speakers/paul-smc.jpg": "3ab5",
	"./events/apidays-live-hongkong/speakers/phil-pro.jpg": "72ca",
	"./events/apidays-live-hongkong/speakers/phil-smc.jpg": "904d",
	"./events/apidays-live-hongkong/speakers/rajesh-pro.jpg": "7f7c",
	"./events/apidays-live-hongkong/speakers/rajesh-smc.jpg": "3509",
	"./events/apidays-live-hongkong/speakers/richard-pro.jpg": "11e7",
	"./events/apidays-live-hongkong/speakers/richard-smc.jpg": "e6cd",
	"./events/apidays-live-hongkong/speakers/rob-pro.jpg": "5eae",
	"./events/apidays-live-hongkong/speakers/rob-smc.jpg": "bd67",
	"./events/apidays-live-hongkong/speakers/samuel-pro.jpg": "4d53",
	"./events/apidays-live-hongkong/speakers/samuel-smc.jpg": "1d1c0",
	"./events/apidays-live-hongkong/speakers/shahnawaz-pro.jpg": "ddce",
	"./events/apidays-live-hongkong/speakers/shahnawaz-smc.jpg": "59b2",
	"./events/apidays-live-hongkong/speakers/simon-pro.jpg": "cf61",
	"./events/apidays-live-hongkong/speakers/simon-smc.jpg": "0b4b",
	"./events/apidays-live-hongkong/speakers/stanley-pro.jpg": "7f2c",
	"./events/apidays-live-hongkong/speakers/stanley-smc.jpg": "e79d",
	"./events/apidays-live-hongkong/speakers/zeev-pro.jpg": "1730",
	"./events/apidays-live-hongkong/speakers/zeev-smc.jpg": "89f6",
	"./events/apidays-live-hongkong/sponsors/alibaba-cloud.png": "5a57",
	"./events/apidays-live-hongkong/sponsors/apisfirst.png": "8820",
	"./events/apidays-live-hongkong/sponsors/auth0.png": "519e",
	"./events/apidays-live-hongkong/sponsors/daops.png": "817c",
	"./events/apidays-live-hongkong/sponsors/forgerock.png": "dfbd",
	"./events/apidays-live-hongkong/sponsors/ibm.png": "d82fc",
	"./events/apidays-live-hongkong/sponsors/nginx.png": "bbd4",
	"./events/apidays-live-hongkong/sponsors/wia.png": "a9a2",
	"./events/apidays-live-hongkong/sponsors/wso2.png": "4b20",
	"./events/apiecobooster/images/apiecobooster.jpg": "5584",
	"./events/apiecobooster/images/coding-2.jpg": "84cd",
	"./events/apiecobooster/images/payment-1.jpg": "0a38",
	"./events/apiecobooster/organisers/benovelty.png": "e3b5",
	"./events/apiecobooster/organisers/hkstp.png": "8c8f",
	"./events/apiecobooster/organisers/hsbc-logo.png": "b188",
	"./events/apiecobooster/organisers/hsbc.png": "4998",
	"./events/community-gallery/apidays-1.jpg": "acf1",
	"./events/community-gallery/apidays-2.png": "c42a",
	"./events/community-gallery/apidays-3.png": "4a7e",
	"./events/community-gallery/apiecobooster-demoday-1.jpg": "9283",
	"./events/community-gallery/apiecobooster-demoday-2.jpg": "79b2",
	"./events/webinars/banners/20200317_open_API_technology_entrepreneurial_journey_sharing.jpg": "f27f",
	"./events/webinars/banners/20200514_api_trends_and_challenges.jpg": "2edd",
	"./events/webinars/banners/20200515_opportunity_for_education_industry_digital_transformation.jpg": "6adb",
	"./events/webinars/banners/20200623_benovelty_taptab_boutir.jpg": "50d1",
	"./events/webinars/banners/20200907_future_of_law_legal_innovations_in_action_today.jpg": "807b",
	"./events/webinars/banners/20200929_local_startup_experience_sharing.jpg": "e52f",
	"./events/webinars/banners/20201022_executive_seminar_technologies_in_finance.jpg": "afba",
	"./events/webinars/banners/20201102_driving_innovations_in_open_banking.jpg": "ebe4",
	"./events/webinars/banners/20201103_fintech_and_the_new_normal.jpg": "0868",
	"./events/webinars/banners/20201112_benovelty_onedegree_fiberapi.jpg": "ff94",
	"./events/webinars/banners/20210329_aws_techconnect_series.png": "a106",
	"./events/webinars/banners/20210812-benovelty-dbs-xero.jpg": "31a6",
	"./events/webinars/banners/20211021-benovelty-dbs-xero.jpg": "ab69",
	"./events/webinars/banners/20211029-local-startup-experience-sharing.jpg": "8045",
	"./events/webinars/banners/20211209-steps-to-build-your-successful-ecommerce-kingdom.jpg": "0fcb",
	"./events/webinars/gallery/20200515-1.jpg": "27ac",
	"./events/webinars/gallery/20200515-2.jpg": "fcdf",
	"./events/webinars/gallery/20200515-3.jpg": "e607",
	"./events/webinars/gallery/20200515-4.jpg": "9b40",
	"./events/webinars/gallery/20200623-1.jpg": "ce83",
	"./events/webinars/gallery/20200623-2.jpg": "178e",
	"./events/webinars/gallery/20200623-3.jpg": "c263",
	"./events/webinars/gallery/20200623-4.jpg": "e767",
	"./events/webinars/gallery/20201102-1.jpg": "7929",
	"./events/webinars/gallery/20201102-2.jpg": "b1b4",
	"./events/webinars/gallery/20201102-3.jpg": "ffc9",
	"./events/webinars/gallery/20201102-4.jpg": "9d18",
	"./events/webinars/gallery/20201112-1.jpg": "7dea",
	"./events/webinars/gallery/20201112-2.jpg": "13fe",
	"./events/webinars/gallery/20201112-3.jpg": "5542",
	"./events/webinars/gallery/20201112-4.jpg": "dcd1",
	"./events/webinars/organisers/aws.png": "b3bb",
	"./events/webinars/organisers/benovelty.png": "d40a",
	"./events/webinars/organisers/boutir.png": "8835",
	"./events/webinars/organisers/cfte.png": "667a",
	"./events/webinars/organisers/cyberport.png": "d44a",
	"./events/webinars/organisers/dbs.png": "2f5e",
	"./events/webinars/organisers/f5.png": "b359",
	"./events/webinars/organisers/fiberapi.png": "c721",
	"./events/webinars/organisers/hkqaa.png": "9ce2",
	"./events/webinars/organisers/hkstp.png": "433b",
	"./events/webinars/organisers/hong_kong_society_for_quality.png": "5af9",
	"./events/webinars/organisers/hsbc-logo.png": "2b53",
	"./events/webinars/organisers/hsbc.png": "3d9f",
	"./events/webinars/organisers/migather.png": "60ae",
	"./events/webinars/organisers/onedegree.png": "0db6",
	"./events/webinars/organisers/solution_forest.png": "c53d",
	"./events/webinars/organisers/taptab.png": "3fcc",
	"./events/webinars/organisers/the_law_society_of_hong_kong.png": "c8f7",
	"./events/webinars/organisers/ust_entrepreneurship_center.png": "f092",
	"./events/webinars/organisers/xero.png": "036e",
	"./images/404.png": "78eb",
	"./images/erb-benovelty.jpg": "4be6",
	"./images/hk01-20201209.jpg": "f480",
	"./images/hk10x-cover1.png": "9406",
	"./images/hk10x-cover2.jpg": "e9f7",
	"./images/wantedly-20200103.jpg": "cb88",
	"./partners/aswatson.png": "055f",
	"./partners/aws.jpg": "e96c",
	"./partners/belun-square.png": "2740",
	"./partners/belun.png": "6a7a",
	"./partners/cmhk.jpeg": "4f1b",
	"./partners/cmhk.png": "9c09",
	"./partners/fbstart.jpg": "e619",
	"./partners/fiberapi.jpg": "68b0",
	"./partners/fiberapi.png": "a8fc",
	"./partners/googleeye.jpg": "4e89",
	"./partners/hkqaa.jpg": "27a5",
	"./partners/hkqaa.png": "009d",
	"./partners/hkstp.jpg": "2ad6",
	"./partners/hkstp.png": "d2f3",
	"./partners/jebsen.png": "e3f3",
	"./partners/jrg.png": "78e5",
	"./partners/kong-color.svg": "19f3",
	"./partners/kong.jpg": "55a9",
	"./partners/kong.png": "a3a6",
	"./partners/mf.jpg": "3cb9",
	"./partners/onedegree.png": "9610",
	"./partners/pearson.jpg": "6d5b",
	"./partners/qfpay-logo.jpg": "b921",
	"./partners/qfpay.jpg": "9a7f",
	"./partners/qfpay.png": "0701",
	"./partners/qfpay.svg": "b193",
	"./partners/spread-it.png": "392d",
	"./partners/sunstar.png": "82cf",
	"./partners/taptab-logo.png": "d7d4",
	"./partners/taptab.jpg": "da38",
	"./partners/telkie.jpg": "8484",
	"./partners/telkie.png": "72ed",
	"./press/cuhk-20221123.jpg": "6078",
	"./press/etnet-20210817.jpg": "8339",
	"./press/etnet-20220811.jpg": "712f",
	"./press/hk01-20201123.jpg": "c04d",
	"./press/hk01-20201209.png": "4bbe",
	"./press/hket-20210602.jpg": "63da",
	"./press/hkstp-20210105.jpg": "3cd0",
	"./press/hkstp-20230831.jpg": "50d4",
	"./press/itpro-20230831.jpg": "4085",
	"./press/unwire-20230904.jpg": "5076",
	"./press/yahoo-20210817.jpg": "1760",
	"./press/yahoo-20220811.jpg": "9a4f",
	"./products/developer-portal/dp-apis.svg": "647d",
	"./products/developer-portal/dp-endpoint.svg": "c8b0",
	"./products/developer-portal/dp-guides.svg": "4737",
	"./products/developer-portal/dp-homepage.svg": "d9bd",
	"./products/developer-portal/dp-pricing.svg": "f02e",
	"./products/fiberconnect/fiber-f2f-payment.png": "7005",
	"./products/fiberconnect/fiber-hero-img.png": "8f82",
	"./products/fiberconnect/fiber-intro.png": "b6e1",
	"./products/fiberconnect/fiber-invoice.png": "c32e",
	"./products/fiberconnect/fiber-remote-payment.png": "a3be",
	"./resource-library/banking-open-api/banking-open-api-cover.jpg": "64ce",
	"./resource-library/banking-open-api/open-apis-benefits.svg": "7152",
	"./resource-library/banking-open-api/open-apis-practices.svg": "e114",
	"./resource-library/banking-open-api/open-apis.svg": "0084",
	"./resource-library/benovelty_onedegree_fiberapi_20201112/images/20201112-banner.jpg": "1a04",
	"./resource-library/benovelty_onedegree_fiberapi_20201112/images/cyber-insurance-faq.jpg": "da7d",
	"./resource-library/benovelty_onedegree_fiberapi_20201112/images/press-cover.jpg": "ae05",
	"./resource-library/case-study/hsbc/hsbc-background.jpg": "85ac",
	"./resource-library/case-study/hsbc/hsbc-blog-cover.jpg": "c75f",
	"./resource-library/case-study/hsbc/hsbc-cover.jpg": "f515",
	"./resource-library/case-study/hsbc/hsbc-gallery.jpg": "ef3a",
	"./resource-library/case-study/hsbc/hsbc-video-thumbnail.jpg": "22ee",
	"./resource-library/pastwebinars/banners/20200317_open_API_technology_entrepreneurial_journey_sharing.jpg": "62f0",
	"./resource-library/pastwebinars/banners/20200514_api_trends_and_challenges.jpg": "2dbc",
	"./resource-library/pastwebinars/banners/20200515_opportunity-for-education-industry-digital-transformation.jpg": "add1",
	"./resource-library/pastwebinars/banners/20200623_benovelty_taptab_boutir.jpg": "ecd6",
	"./resource-library/pastwebinars/banners/20200724_local_start-up_experience_sharing.jpg": "5aa8",
	"./resource-library/pastwebinars/banners/20200907_future_of_law_legal_innovations_in_action_today.jpg": "5f00",
	"./resource-library/pastwebinars/banners/20201022_executive_seminar_technologies_in_finance.jpg": "4fb7",
	"./resource-library/pastwebinars/banners/20201102_driving_innovations_in_open_banking.jpg": "57a5",
	"./resource-library/pastwebinars/banners/20201103_fintech_and_the_new_normal.jpg": "2294",
	"./resource-library/pastwebinars/banners/20201112_benovelty_onedegree_fiberapi.jpg": "0d83",
	"./resource-library/pastwebinars/banners/20210329_aws_techconnect_series.png": "28d0",
	"./resource-library/pastwebinars/banners/20210812-benovelty-dbs-xero.jpg": "7f76",
	"./resource-library/pastwebinars/gallery/20200515-1.jpg": "baa4",
	"./resource-library/pastwebinars/gallery/20200515-2.jpg": "4715",
	"./resource-library/pastwebinars/gallery/20200515-3.jpg": "4472",
	"./resource-library/pastwebinars/gallery/20200515-4.jpg": "34cf",
	"./resource-library/pastwebinars/gallery/20200623-1.jpg": "e20f",
	"./resource-library/pastwebinars/gallery/20200623-2.jpg": "e9e5",
	"./resource-library/pastwebinars/gallery/20200623-3.jpg": "81fd",
	"./resource-library/pastwebinars/gallery/20200623-4.jpg": "f4dc",
	"./resource-library/pastwebinars/gallery/20201102-1.jpg": "dc6f",
	"./resource-library/pastwebinars/gallery/20201102-2.jpg": "6abe",
	"./resource-library/pastwebinars/gallery/20201102-3.jpg": "f6de",
	"./resource-library/pastwebinars/gallery/20201102-4.jpg": "e6b7",
	"./resource-library/pastwebinars/gallery/20201112-1.jpg": "8c16",
	"./resource-library/pastwebinars/gallery/20201112-2.jpg": "fdd1",
	"./resource-library/pastwebinars/gallery/20201112-3.jpg": "940c",
	"./resource-library/pastwebinars/gallery/20201112-4.jpg": "eb35",
	"./resource-library/pastwebinars/organisers/aws.png": "fd0e",
	"./resource-library/pastwebinars/organisers/benovelty.png": "5d4b",
	"./resource-library/pastwebinars/organisers/boutir.png": "44b2",
	"./resource-library/pastwebinars/organisers/cfte.png": "9932",
	"./resource-library/pastwebinars/organisers/cyberport.png": "557f",
	"./resource-library/pastwebinars/organisers/dbs.png": "f67c",
	"./resource-library/pastwebinars/organisers/f5.png": "7970",
	"./resource-library/pastwebinars/organisers/fiberapi.png": "5548",
	"./resource-library/pastwebinars/organisers/hkqaa.png": "afa1",
	"./resource-library/pastwebinars/organisers/hkstp.png": "8ac0",
	"./resource-library/pastwebinars/organisers/hong_kong_society_for_quality.png": "8d4c",
	"./resource-library/pastwebinars/organisers/hsbc.png": "75ad",
	"./resource-library/pastwebinars/organisers/onedegree.png": "233d",
	"./resource-library/pastwebinars/organisers/taptab.png": "8606",
	"./resource-library/pastwebinars/organisers/the_law_society_of_hong_kong.png": "b586",
	"./resource-library/pastwebinars/organisers/ust_entrepreneurship_center.png": "0ce4",
	"./resource-library/pastwebinars/organisers/xero.png": "86e2",
	"./resource-library/webinars/banners/20201112_benovelty_onedegree_fiberapi.jpg": "736a",
	"./resource-library/webinars/banners/20210812-benovelty-dbs-xero.jpg": "98d6",
	"./resource-library/webinars/banners/20211209-steps-to-build-your-successful-ecommerce-kingdom.jpg": "ba60",
	"./resource-library/webinars/gallery/20201112-1.jpg": "fab1",
	"./resource-library/webinars/gallery/20201112-2.jpg": "09b8",
	"./resource-library/webinars/gallery/20201112-3.jpg": "5273",
	"./resource-library/webinars/gallery/20201112-4.jpg": "11c1",
	"./resource-library/webinars/organisers/benovelty.png": "b0f8",
	"./resource-library/webinars/organisers/dbs.png": "a785",
	"./resource-library/webinars/organisers/migather.png": "9856",
	"./resource-library/webinars/organisers/solution_forest.png": "0211",
	"./resource-library/webinars/organisers/xero.png": "e79f",
	"./testimonials/belun.png": "bb11",
	"./testimonials/empty-hsbc.png": "7d88",
	"./testimonials/empty.png": "bff8",
	"./testimonials/fiberapi.png": "be49",
	"./testimonials/hkstp.png": "2417",
	"./testimonials/jebsen.png": "8b0e",
	"./testimonials/qfpay.svg": "7700",
	"./testimonials/spread-it.png": "9b69",
	"./testimonials/sunstar.png": "a16f",
	"./testimonials/telkie.png": "6c93",
	"./thumbnails/about.jpg": "5fd5",
	"./thumbnails/apidays-hongkong-2023.jpg": "a795",
	"./thumbnails/apidays-live-hongkong-2021.jpg": "568d",
	"./thumbnails/apidays-live-hongkong-2022.jpg": "4c19",
	"./thumbnails/apidays-live-hongkong-tc.jpg": "2869",
	"./thumbnails/apidays-live-hongkong.jpg": "d0e8",
	"./thumbnails/apiecobooster.jpg": "a1ed",
	"./thumbnails/careers.jpg": "bf7d",
	"./thumbnails/common.jpg": "62b9",
	"./thumbnails/home.jpg": "82f4",
	"./thumbnails/opportunity-for-education-industry-digital-transformation.jpg": "9029",
	"./thumbnails/partner.jpg": "a750",
	"./thumbnails/trust.jpg": "cdea"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";